export const blockIconsNotificationADB = (
	<span className='material-symbols-outlined'>adb</span>
);
